export const SET_WEBHOOKS = 'SET_WEBHOOKS';
export const ADD_WEBHOOK = 'ADD_WEBHOOK';
export const REPLACE_WEBHOOK = 'REPLACE_WEBHOOK';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';